// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import store from './pathify/store'
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import moment from 'moment'
import momentTimezone from 'moment-timezone'
import VueSweetalert2 from 'vue-sweetalert2'
import VueClipboard from 'vue-clipboard2'
// import VueSessionStorage from 'vue-sessionstorage'
// import * as VueGoogleMaps from 'vue2-google-maps'
import ReadMore from 'vue-read-more'
import VueApollo from 'vue-apollo'

import { ApolloClient } from 'apollo-client'
import { split } from 'apollo-link'
import { HttpLink } from 'apollo-link-http';
import { WebSocketLink } from "apollo-link-ws";
import { InMemoryCache } from 'apollo-cache-inmemory'
import { getMainDefinition } from 'apollo-utilities'
import VueSimpleContextMenu from 'vue-simple-context-menu'
import { Promised } from 'vue-promised'
 
Vue.component('Promised', Promised)
Vue.component('vue-simple-context-menu', VueSimpleContextMenu)
Vue.use(ReadMore)
// Vue.use(VueSessionStorage)
Vue.use(Vuetify)
Vue.use(VueAxios, axios)
Vue.use(moment)
Vue.use(momentTimezone)
Vue.use(VueSweetalert2)
Vue.use(VueClipboard)
Vue.use(VueApollo)
// Vue.use(VueGoogleMaps, {
//   load: {
//     // key: 'AIzaSyA6AtzsjxFSK-3QVsQYiclPEi7wxOdSfyg',
//     placeid: 'ChIJ4ZnvKX274jARFsZN_d404sI',
//     key: 'AIzaSyA0hGnGEcqu2w2eN5XtNUJsNF2Ylv1Vl2g',
//     libraries: 'places' // necessary for places input
//   }
// })
Vue.config.productionTip = false

const httpLink = new HttpLink({
  uri: process.env.VUE_hasura_https,
  fetch,
  headers:  {
      "x-hasura-admin-secret": process.env.VUE_secrete
    }
});


const wsLink = new WebSocketLink({
  // You should use an absolute URL here
  uri: process.env.VUE_hasura_wss,
  options: {
    reconnect: true,
    timeout: 30000,
    connectionParams: () => {
      return { headers: {
                "x-hasura-admin-secret": process.env.VUE_secrete
              } 
      };
    },
  }
})

const link = split(
  // split based on operation type
  ({ query }) => {
    const definition = getMainDefinition(query)
    return definition.kind === 'OperationDefinition' &&
      definition.operation === 'subscription'
  },
  wsLink,
  httpLink
)

// Create the apollo client
const client = new ApolloClient({
  link: link,
  cache: new InMemoryCache({
    addTypename: true
  })
})

const apolloProvider = new VueApollo({
  defaultClient: client,
})

new Vue({
  router,
  store,
  Vuetify,
  apolloProvider,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js